module.exports = __webpack_public_path__ + "static/media/user.98e30bb5.svg";